import React from 'react';

import { Icon, Spinner } from '@iwoca/orion';

class SelectLive extends React.Component {
    state = {
        value: this.props.value || ''
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }

    onChange = (e) => {
        const value = this.props.formatter
            ? this.props.formatter(e.target.value)
            : e.target.value;
        this.setState({ value });
        this.props.onChange && this.props.onChange(value);
    };

    renderIcon = () => {
        const { isLoading } = this.props;
        return !isLoading ? (
            <Icon icon="zoomOutline" />
        ) : (
            <Spinner size="small" />
        );
    };

    render() {
        const {
            onFocus,
            onBlur,
            placeholder,
            onKeyDown,
            onButtonClick,
            inputProps = {}
        } = this.props;
        return (
            <div className="input-group right">
                <input
                    className="form-control"
                    value={this.state.value}
                    onKeyDown={onKeyDown}
                    onChange={this.onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoComplete="off"
                    placeholder={placeholder || 'Search...'}
                    {...inputProps}
                />
                <span
                    className="input-group-addon icon-button"
                    onClick={onButtonClick}>
                    {this.renderIcon()}
                </span>
            </div>
        );
    }
}

export default SelectLive;
